module.exports = __webpack_public_path__ + "static/tacoma0-cf60b47c2a1325c896bde32f072bd05f.webp";